import { conversationApi } from '@formosa/shared/api/im';
import { asId, conversationIdOf } from './travelChatModel';

export const DIRECT_CONVERSATION_ACTIONS = Object.freeze({
  NONE: 'NONE',
  OPEN_EXISTING: 'OPEN_EXISTING',
  ESTABLISH_NEW: 'ESTABLISH_NEW',
});

export function parseDirectCapability(raw) {
  const action = String(raw?.action || '').toUpperCase();
  const conversationId = asId(raw?.conversationId ?? raw?.id);
  if (action === DIRECT_CONVERSATION_ACTIONS.OPEN_EXISTING && conversationId) {
    return { action: DIRECT_CONVERSATION_ACTIONS.OPEN_EXISTING, conversationId };
  }
  if (action === DIRECT_CONVERSATION_ACTIONS.ESTABLISH_NEW) {
    return { action: DIRECT_CONVERSATION_ACTIONS.ESTABLISH_NEW, conversationId: '' };
  }
  if (action === DIRECT_CONVERSATION_ACTIONS.NONE) {
    return { action: DIRECT_CONVERSATION_ACTIONS.NONE, conversationId: '' };
  }
  return null;
}

export async function openDirectConversation(peerMemberId, { navigate, isCurrent, capability } = {}) {
  const peer = asId(peerMemberId);
  if (!peer) {
    throw new Error('找不到這位旅人。');
  }
  const parsed = parseDirectCapability(capability);
  if (parsed?.action === DIRECT_CONVERSATION_ACTIONS.OPEN_EXISTING) {
    if (typeof isCurrent === 'function' && !isCurrent()) return null;
    navigate(`/messages/${parsed.conversationId}`);
    return parsed.conversationId;
  }
  const conversation = await conversationApi.createOrGetDirect(peer);
  if (typeof isCurrent === 'function' && !isCurrent()) return null;
  const conversationId = conversationIdOf(conversation);
  if (!conversationId) {
    throw new Error('無法開始對話，請稍後再試。');
  }
  navigate(`/messages/${conversationId}`);
  return conversationId;
}
